export class InputV3 extends HTMLElement {
  private controller: AbortController;
  private error: HTMLElement | undefined;

  constructor() {
    super();

    this.controller = new AbortController();
  }

  connectedCallback() {
    const input = this.querySelector("input");

    if (input === null) {
      return;
    }

    input.addEventListener(
      "focus",
      () => {
        this.classList.remove("input-invalid");
      },
      {
        signal: this.controller.signal,
      },
    );

    this.querySelectorAll(".input-control").forEach((control) => {
      control.addEventListener(
        "pointerdown",
        (event) => {
          event.stopPropagation();
          event.preventDefault();
        },
        {
          signal: this.controller.signal,
        },
      );
    });

    this.querySelector(".input-control-clear")?.addEventListener(
      "click",
      () => {
        input.value = "";

        const inputEvent = new Event("input", {
          bubbles: true,
          cancelable: true,
        });

        const changeEvent = new Event("change", {
          bubbles: true,
          cancelable: true,
        });

        input.dispatchEvent(inputEvent);
        input.dispatchEvent(changeEvent);
      },
      {
        signal: this.controller.signal,
      },
    );

    this.querySelector(".input-control-password-hidden")?.addEventListener(
      "click",
      () => {
        input.type = "text";
      },
      {
        signal: this.controller.signal,
      },
    );

    this.querySelector(".input-control-password-visible")?.addEventListener(
      "click",
      () => {
        input.type = "password";
      },
      {
        signal: this.controller.signal,
      },
    );
  }

  disconnectedCallback() {
    this.controller.abort();
  }

  setError(error: Error | undefined) {
    if (error !== undefined) {
      this.error = document.createElement("div");
      this.error.classList.add("input-error");
      this.error.replaceChildren(new Text(error.message));

      this.appendChild(this.error);

      this.classList.add("input-invalid");
    } else {
      this.classList.remove("input-invalid");

      this.error?.remove();
    }
  }

  getName() {
    return this.querySelector("input")?.getAttribute("name") ?? "";
  }
}
